
import ListComponent from "../../../components/members/Index.vue";

export default {
  components: {
    ListComponent,
  },
};
